import React, { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Popover from '@mui/material/Popover';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';

const PREFIX = 'RegFormToolbar';

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  spacer: `${PREFIX}-spacer`,
  buttonSpacer: `${PREFIX}-buttonSpacer`,
  copied: `${PREFIX}-copied`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.row}`]: {
    display: 'flex',
  },

  [`& .${classes.spacer}`]: {
    flexGrow: 1,
  },

  [`& .${classes.buttonSpacer}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.copied}`]: {
    padding: theme.spacing(2),
  },
}));

const RegFormToolbar = props => {
  const { className, regForm, save, ...rest } = props;

  const anchorEl = useRef();
  const [copied, setCopied] = useState(false);
  const { copy } = useCopyToClipboard();

  return (
    <Root {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <FormControlLabel
          control={
            <Switch
              checked={regForm.enabled}
              onChange={() => {
                regForm.enabled = !regForm.enabled;
                save(regForm);
              }}
            />
          }
          label={'Включить онлайн регистрацию'}
        />
        <span className={classes.spacer} />
        <a href={'/regform/' + regForm.token} target={'_blank'} rel="noopener noreferrer">
          <Button color='primary' variant='contained' className={classes.buttonSpacer}>
            Показать страницу
          </Button>
        </a>

        <Button
          color='primary'
          variant='contained'
          ref={anchorEl}
          onClick={async () => {
            const success = await copy(window.location.origin + '/regform/' + regForm.token);
            if (success) setCopied(true);
          }}
        >
          Скопировать url
        </Button>
        {copied && (
          <Popover
            open={true}
            anchorEl={anchorEl.current}
            onClose={() => setCopied(false)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Typography className={classes.copied}>URL скопирован</Typography>
          </Popover>
        )}
      </div>
    </Root>
  );
};

export default RegFormToolbar;
